import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76f86f4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay" }
const _hoisted_2 = { class: "overlay-right" }
const _hoisted_3 = { class: "overlay-right-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold"} }, "活动详情", -1))
const _hoisted_5 = { class: "overlay-right-main" }
const _hoisted_6 = { class: "overlay-right-main__reuqire" }
const _hoisted_7 = { class: "overlay-right-main__reuqire-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "文件夹名称：", -1))
const _hoisted_9 = { class: "overlay-right-main__reuqire-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "上传附件数：", -1))
const _hoisted_11 = { class: "overlay-right-main__reuqire-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "项目参与人：", -1))
const _hoisted_13 = { class: "overlay-right-footer" }
const _hoisted_14 = { class: "overlay-left" }

import { withDefaults, watch, ref, nextTick } from 'vue';
import { BaseSvg } from '@/components/base/base-svg/index';
// import { useTaskAudit } from '../hooks/useTaskAudit';
import {
  BaseImageViewer,
  BaseTable,
  useTableColumn,
  BaseTableProps,
  BaseButton
} from 'xrk-components';
import { formatter } from '@/utils/';
import { download } from 'xrk-tools';

export default /*#__PURE__*/_defineComponent({
  __name: 'activty-detail',
  props: {
    remove: {},
    detailInfo: {}
  },
  setup(__props: any) {

const props = __props;

const columns = ref<BaseTableProps['columns']>([
  useTableColumn({
    label: '文件名称',
    prop: 'fileName'
  }),
  useTableColumn({
    label: '文件上传时间',
    prop: 'createAt',
    formatter: ({ cellValue }) => formatter.date(cellValue)
  }),
  useTableColumn({
    label: '操作',
    prop: 'handle',
    render: ({ row }) => {
      return (
        <BaseButton
          type="text"
          click={async () => {
            download.downloadFile(row.fileUrl, {
              fileName: row.fileName
            });
          }}
        >
          下载
        </BaseButton>
      );
    }
  })
]);

// const body = document.body;

const imgViewerShow = ref(true);
const showIndex = ref(0);
// const emits = defineEmits(['auditOver']);

const onChangeActive = index => {
  showIndex.value = index;
};
// const onAudit = async status => {
//   useTaskAudit({
//     auditStatus: status,
//     projectId: props.projectId,
//     queryParams: {
//       sceneType: props.projectType,
//       taskRecordId: [props.id]
//     },
//     auditOver() {
//       emits('auditOver');
//     }
//   });
// };

const picList = ref([]); //图片列表

const init = async () => {
  const imageTypeReg = new RegExp(/\.bmp|\.jpg|\.png|\.gif|\.jpeg/, 'i');
  props.detailInfo.fileList.forEach(item => {
    // item.url 后缀为图片则push
    if (imageTypeReg.test(item.fileUrl)) {
      picList.value.push(item.fileUrl);
    }
  });
  if (!picList.value.length) {
    imgViewerShow.value = false;
  }
};
init();

watch(
  () => showIndex.value,
  () => {
    imgViewerShow.value = false;
    nextTick(() => {
      imgViewerShow.value = true;
    });
  }
);

const onClose = () => {
  props.remove();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            onClick: onClose,
            style: {"cursor":"pointer"}
          }, [
            _createVNode(_unref(BaseSvg), {
              style: {"width":"20px","height":"20px"},
              iconClass: "close"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", null, _toDisplayString(_ctx.detailInfo.folderName), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(_ctx.detailInfo.fileCount), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", null, _toDisplayString(_ctx.detailInfo.peopleNum), 1)
            ])
          ]),
          _createVNode(_unref(BaseTable), {
            style: {"margin-bottom":"16px"},
            columns: columns.value,
            data: _ctx.detailInfo.fileList
          }, null, 8, ["columns", "data"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", null, [
            _createVNode(_unref(BaseButton), {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onClose())),
              type: "default"
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (imgViewerShow.value)
          ? (_openBlock(), _createBlock(_unref(BaseImageViewer), {
              key: 0,
              onSwitch: onChangeActive,
              infinite: true,
              "preview-src-list": picList.value,
              "initial-index": showIndex.value,
              "hide-close": true
            }, null, 8, ["preview-src-list", "initial-index"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})